import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { OptionState } from '../../store/option.reducers';
import { CategoryModel } from '../../models/category.model';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable, Subscription, tap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@shared/services/animations/route.animations';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { optionSelector } from '../../store/option.selectors';
import { AddEditSponsorCategoryComponent } from '../add-edit-sponsor-category/add-edit-sponsor-category.component';
import { optionsCreateCategory, optionsUpdateCategory } from '../../store/option.actions';

@Component({
  selector: 'app-sponsor-type-category',
  templateUrl: './sponsor-type-category.component.html',
  styleUrls: ['./sponsor-type-category.component.scss']
})
export class SponsorTypeCategoryComponent implements OnInit {
@ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  data$!: Observable<CategoryModel[] | OptionState | undefined>;
  dataSource = new MatTableDataSource<CategoryModel>();
  subs$: Subscription[] = [];
  headElements = ['name', 'isActive', 'actions'];
  searchKey!: string;
  constructor(private dialog: MatDialog, private store: Store<OptionState>) { }

  ngOnInit(): void {
    // Bug fix for capitalization in sorting
    this.dataSource.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].toLocaleLowerCase();
    this.data$ = this.store.pipe(select(optionSelector.allOptions)).pipe(tap(options => {
      this.dataSource.data = options.categories.filter(cat => cat.type === 'Sponsor');
      // eslint-disable-next-line arrow-body-style
      this.dataSource.filterPredicate = (data, filter) => {
        // eslint-disable-next-line arrow-body-style
        return this.headElements.some(ele => {
          return ele !== 'actions' && ele !== 'isActive' && data[ele].toLowerCase().indexOf(filter) !== -1;
        });
      };
    }
    ));
  }

  openModal(option: CategoryModel): void {
    const dialogRef = this.dialog.open(AddEditSponsorCategoryComponent, {
      width: '500px',
      data: { ...option }
    });

    // New category
    if (option?.id == null) {
      this.subs$.push(
        dialogRef.afterClosed().subscribe((model: CategoryModel) => {
          if (model != null) {
            this.store.dispatch(optionsCreateCategory({ data: { option: { ...model } } }));
          }
        })
      );
    }

    // Update category
    if (option.id > 0) {
      this.subs$.push(
        dialogRef.afterClosed().subscribe((model: CategoryModel) => {
          if (model != null) {
            this.store.dispatch(optionsUpdateCategory({ data: { option: { ...model } } }));
          }
        })
      );
    }
  }

  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  applyFilter() {
    if (this.searchKey != null) {
      this.dataSource.filter = this.searchKey.trim().toLowerCase();
    }
  }

  sortData(sort: Sort): void {
    this.sort.direction = sort.direction;
    this.sort.active = sort.active;
    this.data$ = this.store.pipe(select(optionSelector.allOptions)).pipe(tap(options => this.dataSource.data = options.categories.filter(cat => cat.type === 'Sponsor')));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.subs$.forEach(sub => sub.unsubscribe());
  }

}
